import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createValidationResult, ValidationError, ValidationResult } from "sprint-common-web";

import { GetDeliveryBucketInfoResponse } from "../../../common/api/delivery-api/GetDeliveryBucketInfoResponse";
import { usePublicDeliveryBucketsApi } from "../api/usePublicDeliveryBucketsApi";

interface DeliverBucketInfo {
    deliveryBucketId: string;
    name: string;
}

export interface AccessKey {
    accessKeyId: string;
    secretAccessKey: string;
}

export const useGenerateAccessKeyPage = () => {
    const [deliveryBucketInfo, setDeliveryBucketInfo] = useState<DeliverBucketInfo>({
        name: "",
        deliveryBucketId: ""
    });
    const [accessKey, setAccessKey] = useState<AccessKey>();
    const [isAccessKeyGenerating, setIsAccessKeyGenerating] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [validationResult, setValidationResult] = useState<ValidationResult>();

    const { generateAccessKey, getDeliveryBucketInfo } = usePublicDeliveryBucketsApi();

    const { token } = useParams<{ token: string }>();

    useEffect(() => {
        getBucketInfo();
    }, []);

    const getBucketInfo = async () => {
        setIsLoading(true);

        getDeliveryBucketInfo({ token })
            .then(({ item }: GetDeliveryBucketInfoResponse) => {
                setDeliveryBucketInfo({ name: item.name, deliveryBucketId: item.deliveryBucketId });
            })
            .catch((err) => {
                if (err instanceof ValidationError) {
                    const result = createValidationResult(err.failures);
                    setValidationResult(result);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const generateBucketAccessKey = () => {
        setIsAccessKeyGenerating(true);

        generateAccessKey({ deliveryBucketId: deliveryBucketInfo.deliveryBucketId })
            .then(({ accessKeyId, secretAccessKey }) => {
                setAccessKey({ accessKeyId, secretAccessKey });
            })
            .catch((error) => {
                if (error instanceof ValidationError) {
                    const result = createValidationResult(error.failures);
                    setValidationResult(result);
                }
            })
            .finally(() => {
                setIsAccessKeyGenerating(false);
            });
    };

    return {
        isAccessKeyGenerating,
        deliveryBucketInfo,
        isLoading,
        accessKey,
        validationResult,
        generateBucketAccessKey
    };
};
